<template>
  <div class="fill-height">
    <v-card class="fill-height" >
      <v-card-title>
        <v-chip small color="primary">نتیچه پرداخت</v-chip>
        <v-spacer/>

      </v-card-title>
      <v-card-text>
        <v-row  v-if="model.respcode===0">

          <v-col cols="12" sm="6" offset-sm="3"  >
            <v-card style="float: right;text-align: right"  >
              <v-toolbar dense  dark style="display: block"  color="success">
                <v-toolbar-title>عملیات با موفقیت انجام شد</v-toolbar-title>
                <v-spacer/>
                <v-btn style="background-color:transparent" dark icon small fab>
                  <v-icon >mdi-file-pdf-box</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text  ><span style="">نتیجه تراکنش:</span>{{model.respmsg}}</v-card-text>
              <v-card-text class="mt-3" > مبلغ پرداختی:{{model.amountText}} ریال</v-card-text>
              <v-card-text >سریال خرید:{{model.invoiceID}}</v-card-text>
              <v-card-text >شماره پیگیری:{{model.tracenumber}}</v-card-text>
              <v-card-text >تاریخ و ساعت :{{model.datePaid}}</v-card-text>
              <v-card-text >رسید دیجیتال :{{model.digitalreceipt}}</v-card-text>
              <v-card-text >شماره کارت :{{model.cardnumber}}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row  v-if="model.respcode!==0"  >
<v-col cols="12" sm="6" offset-sm="3"  >
  <div id="content" ref="content" >

    <v-card >
      <v-toolbar dense  dark style="display: block"  color="error">
        <v-toolbar-title>   عملیات ناموفق بود!</v-toolbar-title>
        <v-spacer/>
        <v-btn style="background-color:transparent" dark icon small fab >
          <v-icon >fa fa-exclamation-triangle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-3" > مبلغ پرداختی:{{model.amountText}} ریال</v-card-text>
      <v-card-text >تاریخ :{{model.paymentDateText}}</v-card-text>


    </v-card>
  </div>
</v-col>

        </v-row>
      </v-card-text>
      <v-card-actions dir="ltr">
        <v-btn
            small
            depressed
            color="warning"
            class=" pr-1 pl-1"
           @click="closed"

        >
        بازگشت به صفحه اصلی
        </v-btn>
        <v-btn
            small
            depressed
            color="success"
            class=" pr-1 pl-1 m-2"
            @click="download"

        >
          دانلود رسید پرداخت
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import 'jspdf-autotable'
import Account_se from "@/views/define/account/Account_se";
import {mapMutations} from "vuex";


export default {
  name: 'PCBsi',
  data() {
    return {
      id: '',
      model: {},
      result: false,

    }
  },
  methods: {
    download() {
      Account_se.exportPdf(this.id)
    },

    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.$root.$emit('Account')
      this.$router.push("/home")
    },


    getCallBack: function () {
      this.id = this.$route.params.id
      Account_se.getCallBackBsi(this.id).then(response => {
        this.model = response.data.model
      })
    },


  },
  created() {
    this.setDrawer(false)
    this.getCallBack()
  }
}


</script>


